import React, { ReactNode, useState } from "react";
import * as S from "./styles.ts";
import { ChevronDown } from "@template/icons";

export interface IDropdownProps {
  trigger: ReactNode;
  children: ReactNode;
}

const Dropdown = ({ trigger, children }: IDropdownProps) => {
  const [expanded, setExpanded] = useState<boolean>(false);

  return (
    <S.DropdownContainer>
      <S.DropdownTitle onClick={() => setExpanded(!expanded)}>
        {trigger}
        <ChevronDown />
      </S.DropdownTitle>
      <S.DropdownContent $expanded={expanded}>{children}</S.DropdownContent>
    </S.DropdownContainer>
  );
};

export default Dropdown;
